import { render, staticRenderFns } from "./MultiVariant.vue?vue&type=template&id=0b68bb80&"
import script from "./MultiVariant.vue?vue&type=script&lang=js&"
export * from "./MultiVariant.vue?vue&type=script&lang=js&"
import style0 from "./MultiVariant.vue?vue&type=style&index=0&id=0b68bb80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports